import {
  tag_styles_default
} from "./chunk.5DPYJIRK.js";
import {
  LocalizeController
} from "./chunk.RQU6SOEM.js";
import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  emit
} from "./chunk.T3VOOO5F.js";
import {
  e,
  n
} from "./chunk.5E26GMTR.js";
import {
  $,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.APX6YS4T.js
var SlTag = class extends s4 {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController(this);
    this.variant = "neutral";
    this.size = "medium";
    this.pill = false;
    this.removable = false;
  }
  handleRemoveClick() {
    emit(this, "sl-remove");
  }
  render() {
    return $`<span part="base" class=${o({
      tag: true,
      "tag--primary": this.variant === "primary",
      "tag--success": this.variant === "success",
      "tag--neutral": this.variant === "neutral",
      "tag--warning": this.variant === "warning",
      "tag--danger": this.variant === "danger",
      "tag--text": this.variant === "text",
      "tag--small": this.size === "small",
      "tag--medium": this.size === "medium",
      "tag--large": this.size === "large",
      "tag--pill": this.pill,
      "tag--removable": this.removable
    })} ><span part="content" class="tag__content"><slot></slot></span>${this.removable ? $`<sl-icon-button part="remove-button" exportparts="base:remove-button__base" name="x" library="system" label=${this.localize.term("remove")} class="tag__remove" @click=${this.handleRemoveClick} ></sl-icon-button>` : ""}</span>`;
  }
};
SlTag.styles = tag_styles_default;
__decorateClass([
  e({ reflect: true })
], SlTag.prototype, "variant", 2);
__decorateClass([
  e({ reflect: true })
], SlTag.prototype, "size", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlTag.prototype, "pill", 2);
__decorateClass([
  e({ type: Boolean })
], SlTag.prototype, "removable", 2);
SlTag = __decorateClass([
  n("sl-tag")
], SlTag);

export {
  SlTag
};
